import { loadDismissScrollMore, setDismissScrollMore } from "utils/storage";
import { ICurrentUser } from "store/user/user-state";
import { updateUserSettings } from "store/user/user-action";
import { useDispatch } from "react-redux";

export const useDismissScrollMore = (user: ICurrentUser) => {
  const dispatch = useDispatch();

  return {
    isDismissScrollMore: () => {
      let value = loadDismissScrollMore() || false;

      if (user && user?.settings?.dismiss_scroll_more) {
        value = true;
      }

      return value;
    },
    dismissScrollMore: () => {
      setDismissScrollMore(true);

      if (user && Object.entries(user).length > 0) {
        dispatch(updateUserSettings({
          dismiss_scroll_more: true,
        }));
      }
    }
  };
};
